import { useState, useEffect, useRef } from "react";
import { Input } from "./ui/input";

// Free-text input that suggests known values. Never blocks a new value.
// fetcher: async (query) => [{ id, name }]
export function Autocomplete({ value, onChange, fetcher, placeholder, testId, disabled }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    let active = true;
    const t = setTimeout(async () => {
      try {
        const res = await fetcher(value || "");
        if (active) setItems(Array.isArray(res) ? res : []);
      } catch { /* noop */ }
    }, 180);
    return () => { active = false; clearTimeout(t); };
  }, [value, open]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      <Input
        data-testid={testId}
        value={value || ""}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
      />
      {open && items.length > 0 && (
        <div data-testid={`${testId}-list`}
          className="absolute z-50 mt-1 w-full max-h-56 overflow-auto rounded-lg border border-[#E5DEC9] bg-white shadow-lg">
          {items.map((it) => (
            <button
              key={it.id}
              type="button"
              data-testid={`${testId}-opt-${it.id}`}
              onMouseDown={(e) => { e.preventDefault(); onChange(it.name); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[#F0EAE1] text-[#1B3B2B]">
              {it.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
